<template>
  <div
    class="dropdown-wrappper"
    :class="{ 'dropdown-wrappper--disabled': disabled }"
    @click.stop
  >
    <main @click="searchFocused = true">
      <input
        v-model="search"
        :placeholder="getPlaceholder()"
        @focus="searchFocused = true"
        @blur="alwaysFocused ? null : (searchFocused = false)"
      />
      <span class="tms search">N</span>
      <span v-if="searchFocused" class="tms2" @click.stop="closeDD()">f</span>
      <span v-else class="tms" @click.stop="searchFocused = true">K</span>
    </main>
    <div class="dd" v-if="searchFocused">
      <div
        class="option"
        :class="{'option--disabled': g.disabled}"
        v-for="g in filteredList"
        :key="g._id"
      >
        <Checkbox
          v-model="g.selected"
          :disabled="disabled || g.disabled"
          :label="g.isWorkerGroup && g.worker ? `${g.worker.name} - ${g.name}` : g.name"
        >
          <span class="tms tms--role tms--brown" v-if="g.isWorkerGroup">1</span>
          <span class="tms tms--role tms--blue" v-else-if="g.permissions">y</span>
          <span class="tms tms--role tms--blue" v-else>0</span>
        </Checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "./Checkbox.vue";
export default {
  props: ["planning", "list", "alwaysFocused", "disabled"],
  components: {
    Checkbox,
  },
  data() {
    return {
      loading: false,
      search: "",
      searchFocused: false,
    };
  },
  computed: {
    filteredList() {
      let output = [];
      output = output.concat(
        this.list.filter((g) =>
          g.name.toLowerCase().includes(this.search.toLowerCase())
        )
      );

      return output;
    },
    selectedOptions() {
      const output = [];
      for (let g of this.list) {
        if (g.selected) output.push(g);
      }

      return output;
    },
  },
  methods: {
    getPlaceholder() {
      if (this.selectedOptions.length) {
        return this.selectedOptions.map((g) =>
          g.isWorkerGroup ? `${g.worker.name} - ${g.name}` : g.name
        );
      } else return "Търсене";
    },
    closeDD() {
      if (!this.alwaysFocused) this.searchFocused = false;
    },
    select() {
      this.$emit("input");
    },
  },
  mounted() {
    if (this.alwaysFocused) this.searchFocused = true;
  },
};
</script>

<style lang="scss" scoped>
.dropdown-wrappper {
  display: inline-flex;
  font-size: 12px;
  gap: 5px;
  flex-direction: column;
  position: relative;
  width: 100%;

  &.dropdown-wrappper--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  > main {
    align-items: center;
    background: #fff;
    border: 1px solid #cecece;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    gap: 9px;
    height: 36px;
    padding: 0 14px;
    width: 100%;
    > .tms:first-child {
      color: #0057bb;
      font-size: 20px;
    }
    > .tms.search {
      color: #486ec2;
      font-size: 14px;
      left: 14px;
      position: absolute;
      top: 10px;
    }
    > .tms:last-child {
      color: #486ec2;
      &.reversed {
        transform: scaleY(-1);
      }
    }

    input {
      background: transparent;
      border: none;
      font-size: 12px;
      height: 100%;
      outline: none;
      padding: 0 0 0 20px;
      &::placeholder {
        color: #737373;
      }
    }

    p {
      font-weight: 700;
      width: 100%;
      &.selected {
        line-height: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        white-space: nowrap;
        .tms {
          font-weight: 400;
          margin: 0 10px;
          vertical-align: middle;
        }
      }
    }
  }

  .dd {
    background: #fff;
    border: 1px solid #cecece;
    border-radius: 4px;
    display: block;
    overflow: auto;
    max-height: 250px;
    top: calc(100% + 3px);
    width: 100%;
    z-index: 1;

    p {
      padding: 5px 0;
    }

    .tms--role {
      margin: initial;
      top: initial;
    }
  }
}
</style>
